import { axiosInstanceV2 } from "@src/shared/api";
import { useAuthStore } from "@src/entities/login/model/store/authStore";
import { RATING_API_URL } from "../constants";

interface ISendRatingRequestDto {
  user_id: number;
  rating: string;
}

export const sendRating = (data: ISendRatingRequestDto) => {
  const { rating, user_id } = data;
  const access_token = useAuthStore.getState().user?.tokens.access_token;
  return axiosInstanceV2.post(
    RATING_API_URL.getRatingUrl(user_id, rating),
    {},
    {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    }
  );
};
